import { ELkType } from '../../types/lkType';
import { IApplicationState } from '../../types/redux';

export function selectIsRealtor(state: IApplicationState): boolean {
  return state.user.isAuthenticated && state.user.userType === ELkType.Specialist && !state.user.isBuilder;
}
